import script from "./CollectionProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionProduct.vue?vue&type=script&setup=true&lang=js"

import "./CollectionProduct.vue?vue&type=style&index=0&id=4a7921f8&lang=scss"

const __exports__ = script;

export default __exports__